import React, { useEffect, useState } from 'react';
import {NavLink, useHistory} from "react-router-dom";
import {Form, Button} from 'react-bootstrap';
import api from '../../services/api';
import { toast } from 'react-toastify';

const AudioMatchingStreamForm = (props) => {
    const [Tokens, setTokens] = useState([]);
    const [Token, setToken] = useState(0);
    const [StreamType, setStreamType] = useState('Hls');
    const [Url, setUrl] = useState('');
    const [Servers, setServers] = useState([]);
    const [Server, setServer] = useState(0);
    const [Enabled, setEnabled] = useState(true);
    const [Retain, setRetain] = useState(false);
    const [LastRegistered, setLastRegistered] = useState(null);
    const [LastRegisterError, setLastRegisterError] = useState('');
    const [LiveStatus, setLiveStatus] = useState(null);
    const [statusLoading, setStatusLoading] = useState(false);
    const [statusError, setStatusError] = useState('');
    const [loadingData, setLoadingData] = useState(false);
    const [id, setId] = useState(props?.location?.aboutProps?.id);
    const history = useHistory();

    const getById = async () => {
        if (id > 0) {
            setLoadingData(true);
            try {
                api.get("amstream/" + id)
                    .then(function (response) {
                        if (response.status == 200) {
                            var result = response.data;
                            setToken(result.token);
                            setStreamType(result.stream_type);
                            setUrl(result.url);
                            setServer(result.server);
                            setEnabled(result.is_active);
                            setRetain(result.retain);
                            setLastRegistered(result.last_registered);
                            setLastRegisterError(result.last_register_error);
                        }
                        setLoadingData(false);
                    })
                    .catch(function (error) {
                        toast.error('An error occurred !', {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setLoadingData(false);
                    });
            } catch (err) {
                toast.error('An error occurred !', {
                    position: toast.POSITION.TOP_RIGHT
                });
                setLoadingData(false);
            }
        }
    }

    const saveData = async (e) => {
        e.preventDefault();
        setLoadingData(true);
        const payload = {
            stream_type: StreamType,
            url: Url,
            server: Server > 0 ? Server : e.target.elements.Server.value,
            is_active: Enabled,
            retain: Retain
        };
        const onError = (error) => {
            const detail = error?.response?.data;
            const message = detail && typeof detail === 'object'
                ? Object.values(detail).flat().join(' ')
                : 'An error occurred !';
            toast.error(message, {
                position: toast.POSITION.TOP_RIGHT
            });
            setLoadingData(false);
        };
        try {
            if (id > 0) {
                // The token of a stream cannot be changed once created.
                api.put('amstream/' + id, payload)
                    .then(function (response) {
                        if (response.status == 200 || response.status == 204) {
                            toast.success('Successful Operation !', {
                                position: toast.POSITION.TOP_RIGHT
                            });
                            return history.push('/manage/amstreams');
                        }
                    })
                    .catch(onError);
            } else {
                payload.token = Token > 0 ? Token : e.target.elements.Token.value;
                api.post('amstream', payload)
                    .then(function (response) {
                        if (response.status == 200 || response.status == 204) {
                            toast.success('Successful Operation !', {
                                position: toast.POSITION.TOP_RIGHT
                            });
                            return history.push('/manage/amstreams');
                        }
                    })
                    .catch(onError);
            }
        } catch (err) {
            setLoadingData(false);
        }
    }

    const checkStatus = async () => {
        setStatusLoading(true);
        setStatusError('');
        try {
            api.get('amstream/' + id + '/status')
                .then(function (response) {
                    if (response.status == 200) {
                        setLiveStatus(response.data);
                    }
                    setStatusLoading(false);
                })
                .catch(function (error) {
                    const detail = error?.response?.data?.detail;
                    setStatusError(detail || 'Could not reach the AM server.');
                    setLiveStatus(null);
                    setStatusLoading(false);
                });
        } catch (err) {
            setStatusError('Could not reach the AM server.');
            setStatusLoading(false);
        }
    }

    const formatCaptured = (seconds) => {
        if (!seconds || seconds <= 0) return 'none yet';
        const mins = Math.floor(seconds / 60);
        const secs = Math.round(seconds % 60);
        return mins > 0 ? `${mins} min ${secs}s` : `${secs}s`;
    }

    const getTokens = async () => {
        setLoadingData(true);
        try {
            api.get('tokens?limit=1000')
                .then(function (response) {
                    if (response.status == 200) {
                        setTokens(response.data.results);
                    }
                    setLoadingData(false);
                })
                .catch(function (error) {
                    setLoadingData(false);
                });
        } catch (err) {
            setLoadingData(false);
        }
    }

    const getServers = async () => {
        try {
            api.get('amservers?limit=1000')
                .then(function (response) {
                    if (response.status == 200) {
                        setServers(response.data.results.filter(s => s.is_active));
                    }
                })
                .catch(function (error) {
                });
        } catch (err) {
        }
    }

    useEffect(() => {
        getTokens();
        getServers();
        getById();
        var selector = document.getElementById('title-section-id');
        if (selector != undefined) {
            if (id > 0)
                selector.textContent = "Edit Audio Matching Stream";
            else
                selector.textContent = "Create Audio Matching Stream";
        }
    }, []);

    return (
        <>
            <div className={loadingData ? "preload" : "d-none"}><div className="preloader-spinner"></div></div>
            <Form className="create-form" onSubmit={saveData} autoComplete="off">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Token</Form.Label>
                                    <select className="form-control" name="Token" value={Token} disabled={id > 0} onChange={(e) => setToken(e.target.value)}>
                                        {Tokens.map((item, i) => (
                                            <option key={i} value={item.id}>{item.name}</option>
                                        ))}
                                    </select>
                                    {id > 0 ? <small className="form-text text-muted">The token of a stream cannot be changed.</small> : null}
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>AM Server</Form.Label>
                                    <select className="form-control" name="Server" value={Server} onChange={(e) => setServer(e.target.value)}>
                                        {Servers.map((item, i) => (
                                            <option key={i} value={item.id}>{item.name} ({item.hostname})</option>
                                        ))}
                                    </select>
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Stream Type</Form.Label>
                                    <select className="form-control" name="StreamType" value={StreamType} onChange={(e) => setStreamType(e.target.value)}>
                                        <option value="Hls">HLS</option>
                                        <option value="Srt">SRT</option>
                                    </select>
                                    <small className="form-text text-muted">The transport protocol of the source stream.</small>
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-12 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Stream URL</Form.Label>
                                    <Form.Control type="text" required placeholder={StreamType === 'Srt' ? 'srt://radio.example:9000?mode=caller' : 'https://radio.example/live.m3u8'} value={Url} onChange={(e) => setUrl(e.target.value)} />
                                    <small className="form-text text-muted">For HLS, the live .m3u8 playlist URL. For SRT, a caller-mode URL (srt://host:port?mode=caller). Update this per event when the stream changes.</small>
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Enabled</Form.Label>
                                    <Form.Check name="Enabled" type="checkbox" checked={Enabled} onChange={(e) => setEnabled(!Enabled)} />
                                    <small className="form-text text-muted">When disabled, the stream is unregistered from the AM server and matching stops.</small>
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Retain for VOD</Form.Label>
                                    <Form.Check name="Retain" type="checkbox" checked={Retain} onChange={(e) => setRetain(!Retain)} />
                                    <small className="form-text text-muted">When enabled, the whole recording is catalogued so the stream stays identifiable for on-demand/VOD playback long after the live event. Only enable for streams that need VOD matching.</small>
                                </Form.Group>
                            </div>
                            {id > 0 ?
                                <div className="mb-3 col-md-6 col-sm-12">
                                    <Form.Group className="form-group">
                                        <Form.Label>Registration Status</Form.Label>
                                        <div>
                                            {LastRegisterError
                                                ? <span className="text-danger">{LastRegisterError}</span>
                                                : LastRegistered
                                                    ? <span className="text-success">Registered {new Date(LastRegistered).toLocaleString()}</span>
                                                    : <span className="text-muted">Not registered yet</span>}
                                        </div>
                                    </Form.Group>
                                </div>
                                : null}
                            {id > 0 ?
                                <div className="mb-3 col-md-6 col-sm-12">
                                    <Form.Group className="form-group">
                                        <Form.Label>Live Status</Form.Label>
                                        <div className="mb-2">
                                            <Button type="button" className="btn btn-sm btn-outline-primary" disabled={statusLoading} onClick={checkStatus}>
                                                <i className="fa fa-fw fa-refresh"></i> {statusLoading ? 'Checking…' : 'Check live status'}
                                            </Button>
                                        </div>
                                        {statusError
                                            ? <span className="text-danger">{statusError}</span>
                                            : LiveStatus
                                                ? <div>
                                                    <div>State: <span className={(LiveStatus.status === 'ingesting' || LiveStatus.status === 'completed') ? 'text-success' : 'text-muted'}>{LiveStatus.status}</span></div>
                                                    <div>Captured: <strong>{formatCaptured(LiveStatus.capturedSeconds)}</strong></div>
                                                    {LiveStatus.ingestStartUtc
                                                        ? <div className="text-muted"><small>Since {new Date(LiveStatus.ingestStartUtc).toLocaleString()}</small></div>
                                                        : null}
                                                </div>
                                                : <span className="text-muted"><small>Fetches current lifecycle and captured audio duration from the AM server.</small></span>}
                                    </Form.Group>
                                </div>
                                : null}
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-12 footer-form">
                                <NavLink className="btn btn-secondary" to="/manage/amstreams"><i className="fa fa-fw fa-times"></i> Cancel</NavLink>
                                <Button className="btn btn-primary" type='submit'><i className="fa fa-fw fa-floppy-o"></i> Save</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </>
    );
};

export default AudioMatchingStreamForm;
